<template>
  <div class="measureSets-view">
    <div v-if="company">
      <div style="margin-bottom:50px">
        <SidebarToggleView />
        <span class="display-2">TOMs | {{ company.name }}</span>
        <span style="float:right"
          ><v-btn outlined color="primary" v-on:click="onCreateNew()">Allgemeine TOM Hinzufügen</v-btn></span
        >
      </div>
      <v-toolbar>
        <v-toolbar-items>
          <v-btn text :class="sort_var == 'seq_nr' ? 'primary--text' : ''" v-on:click="sortMeasureSets('seq_nr')"
            >Nr.
            <v-icon v-if="sort_var == 'seq_nr'" small>{{
              sort_order == "ASC" ? "arrow_downward" : "arrow_upward"
            }}</v-icon></v-btn
          >
          <v-btn
            text
            :class="sort_var == 'text_header' ? 'primary--text' : ''"
            v-on:click="sortMeasureSets('text_header')"
          >
            Name
            <v-icon v-if="sort_var == 'text_header'" small>{{
              sort_order == "ASC" ? "arrow_downward" : "arrow_upward"
            }}</v-icon></v-btn
          >
          <v-btn text :class="sort_var == 'updatedAt' ? 'primary--text' : ''" v-on:click="sortMeasureSets('updatedAt')"
            >Datum
            <v-icon v-if="sort_var == 'updatedAt'" small>{{
              sort_order == "ASC" ? "arrow_downward" : "arrow_upward"
            }}</v-icon></v-btn
          >
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-text-field
          hide-details
          class="ml-2"
          v-model="search"
          placeholder="Suche in allgemeinen TOMs"
          append-icon="search"
          @click:append="() => (openSearch = !openSearch)"
        >
        </v-text-field>
      </v-toolbar>

      <v-row>
        <v-col>
          <v-card>
            <v-list two-line>
              <template v-for="(measureSet, index) in company.measureSets.items">
                <v-list-item @click="onClick(measureSet)">
                  <v-list-item-avatar> Nr. {{ measureSet.seq_nr }} </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title><span v-html="highlightSearch(measureSet.type)"></span> </v-list-item-title>
                    <v-list-item-subtitle>{{ measureSet.updatedAt | moment("llll") }} </v-list-item-subtitle>
                  </v-list-item-content>
                  <!--to show search results if available-->
                  <v-list-item-content>
                    <v-list-item-title class="text-lg-right" two-line v-html="getMatchingPart(measureSet)">
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <span
                      ><v-icon
                        class="mt-2"
                        small
                        style="float:left"
                        :color="
                          measureSet.status == 'SPECIFIED' || measureSet.status == 'COMPLETED'
                            ? 'info'
                            : 'grey lighten-2'
                        "
                        >brightness_1</v-icon
                      ></span
                    >
                    <span
                      ><v-icon
                        class="mb-1"
                        small
                        style="float:left"
                        :color="measureSet.status == 'COMPLETED' ? 'info' : 'grey lighten-2'"
                        >brightness_1</v-icon
                      ></span
                    >
                  </v-list-item-action>
                </v-list-item>
              </template>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <MeasureCreateView
      :showThis="show_measureSet_create_view"
      :company_id="company_id"
      v-on:discard="show_measureSet_create_view = false"
    >
    </MeasureCreateView>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import MeasureCreateView from "./MeasureCreateView";
import SidebarToggleView from "./SidebarToggleView";

import XLSX from "xlsx";

String.prototype.format = function() {
  return [...arguments].reduce((p, c) => p.replace(/%s/, c), this);
};

const getCompany = `query GetCompany($id: ID!) {
  getCompany(id: $id) {
    id
    name
    measureSets(limit:50, nextToken: %s) {
        items {
            id
            seq_nr
            type
            description
            commentatory
            status
            updatedAt
        }
        nextToken
    }
  }
}
`;

const sortByASC = function(arr, prop, cIns) {
  if (cIns) {
    return arr.sort((a, b) =>
      String(a[prop]).toLowerCase() < String(b[prop]).toLowerCase()
        ? -1
        : String(a[prop]).toLowerCase() > String(b[prop]).toLowerCase()
        ? 1
        : 0
    );
  }
  return arr.sort((a, b) => (a[prop] < b[prop] ? -1 : a[prop] > b[prop] ? 1 : 0));
};
const sortByDESC = function(arr, prop, cIns) {
  if (cIns) {
    return arr.sort((a, b) =>
      String(a[prop]).toLowerCase() < String(b[prop]).toLowerCase()
        ? 1
        : String(a[prop]).toLowerCase() > String(b[prop]).toLowerCase()
        ? -1
        : 0
    );
  }

  return arr.sort((a, b) => (a[prop] < b[prop] ? 1 : a[prop] > b[prop] ? -1 : 0));
};

const sortBy = function(arr, prop, how, cIns) {
  return how == "ASC" ? sortByASC(arr, prop, cIns) : sortByDESC(arr, prop, cIns);
};

const TEXT_FIELDS = ["description", "commentatory"];
// define the HINT lengths
const HINT_LENGTH = 20;
// max length of chars before hint starts
const HINT_BEFORE = 10;
// max length of chars after hint ends
const HINT_AFTER = 50;
// Note: can't use import syntax for this because the module
// does not export anything, nor declares any global vars in main file
let JsSearch = require("js-search");

import { createMeasureSet } from "../graphql/mutations";

export default {
  name: "MeasuresView",
  components: {
    MeasureCreateView,
    SidebarToggleView,
  },
  props: {
    msg: String,
  },
  watch: {
    search: {
      handler(val) {
        if (val.length > 0) {
          // take backup of original company measureSets
          // this if statement makes sure that we retain the original number of measureSets
          // and not filtered ones
          if (this.measureSetsCache.length < this.company.measureSets.items.length) {
            // clone the array(instead of assigning it)
            this.measureSetsCache = this.company.measureSets.items.slice(0);
          }
          this.company.measureSets.items = this.searcher.search(val);
          this.sort_var = "";
          this.sort_order = "ASC";
        } else {
          if (this.company) {
            // restore the original number of measureSet items
            this.company.measureSets.items = this.measureSetsCache;
          }
        }
      },
      sort_var: {
        handler(val) {},
      },
    },
  },
  computed: {
    company_id() {
      return this.$route.params.id;
    },
    measureSet_max_seq_nr: {
      get() {
        return this.$store.state.measureSet_max_seq_nr;
      },
      set(value) {
        this.$store.commit("SET_measureSet_max_seq_nr", value);
      },
    },
  },
  mounted() {
    this.getContent(this.company_id);
    this.searcher.indexStrategy = new JsSearch.AllSubstringsIndexStrategy();
    // add the field on which to search
    this.searcher.addIndex("label");
    this.searcher.addIndex("description");
    this.searcher.addIndex("commentatory");
  },
  methods: {
    onGoToImport() {
      this.$router.push({ path: `import` });
    },
    onClick(item) {
      this.$router.push({ path: `measure/${item.id}` });
    },
    onCreateNew() {
      //this.$router.push({ path: `measure/new` });
      this.show_measureSet_create_view = true;
    },
    getContent(company_id, nextToken) {
      this.$Amplify.API.graphql(
        this.$Amplify.graphqlOperation(getCompany.format(nextToken ? '"' + nextToken + '"' : null), { id: company_id })
      ).then((res) => {
        if (this.company == null) {
          this.company = res.data.getCompany;
        } else {
          this.company.measureSets.items.push(...res.data.getCompany.measureSets.items);
        }
        // add the search items
        this.searcher.addDocuments(res.data.getCompany.measureSets.items);
        this.measureSet_max_seq_nr = Math.max(
          0,
          ...this.company.measureSets.items.map((measureSet) => measureSet.seq_nr)
        ); // store the maximum sequence number for this company (to be used for a new measureSet)

        if (this.sort_var === "seq_nr") {
          sortBy(this.company.measureSets.items, this.sort_var, this.sort_order);
        } else {
          sortBy(this.company.measureSets.items, this.sort_var, this.sort_order, true);
        }
        var nextToken = res.data.getCompany.measureSets.nextToken;
        if (nextToken !== null) {
          this.getContent(company_id, nextToken);
        }
      });
    },
    highlightSearch(text) {
      if (!this.search) {
        return text;
      }
      let retVal = text.replace(new RegExp(this.search, "gi"), (match) => {
        return '<span style="background:#f5ea4c">' + match + "</span>";
      });

      return retVal;
    },
    getMatchingPart(obj) {
      if (!this.search) {
        return "";
      }

      let matVal = null;
      let keys = TEXT_FIELDS;
      for (let i = 0; i < keys.length; i++) {
        let curKey = keys[i];
        let curVal = obj[curKey];
        let match = new RegExp(this.search, "i").exec(curVal);
        if (match == null) {
          continue;
        }

        // find the begin and end index
        let begin = Math.max(0, match.index - (HINT_LENGTH - this.search.length) - HINT_BEFORE);
        let end = Math.min(begin + HINT_BEFORE + HINT_LENGTH + HINT_AFTER, curVal.length - 1);
        let originalLength = curVal.length;
        curVal = curVal.substring(begin, end);

        // trim the uncompleted texts from begin and end
        curVal = curVal.substring(curVal.indexOf(" "), curVal.lastIndexOf(" "));
        matVal = curVal.replace(new RegExp(this.search, "i"), (mat) => {
          return '<span style="background:#f5ea4c">' + mat + "</span>";
        });

        if (matVal !== curVal) {
          break;
        }
      }

      return matVal;
    },
    sortMeasureSets(field) {
      if (this.sort_var == field) {
        // change the sort order
        this.sort_order = this.sort_order == "ASC" ? "DESC" : "ASC";
      } else {
        this.sort_var = field;
        this.sort_order = "ASC";
      }
      if (this.sort_var === "seq_nr") {
        sortBy(this.company.measureSets.items, this.sort_var, this.sort_order);
      } else {
        var self = this;
        sortBy(this.company.measureSets.items, this.sort_var, this.sort_order, true);
      }
    },
  },
  data: () => ({
    company: null,
    response: null,
    sort_var: "seq_nr",
    sort_order: "ASC",
    measureSetsCache: [],
    search: "",
    searcher: new JsSearch.Search("id"),
    show_measureSet_create_view: false,
  }),
  beforeRouteUpdate(to, from, next) {
    this.company = null;
    this.measureSetsCache = [];
    this.search = "";
    this.searcher = new JsSearch.Search("id");
    this.sort_var = "seq_nr";
    this.sort_order = "ASC";
    //this.getContent(to.params.id);
    // set the searcher index strategy
    this.searcher.indexStrategy = new JsSearch.AllSubstringsIndexStrategy();
    // add the field on which to search
    this.searcher.addIndex("label");
    this.searcher.addIndex("description");
    this.searcher.addIndex("commentatory");
    this.getContent(to.params.id).then((res) => {
      next();
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.active-btn {
  background: red;
}
</style>
